import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "errors-server-issue" }
const _hoisted_2 = { class: "errors-server-issue__title" }
const _hoisted_3 = { class: "errors-server-issue__text px-10" }
const _hoisted_4 = { class: "text--center" }


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const reload = () => {
  window.location.href = "/";
}

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("errors.serverIssue.title")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("errors.serverIssue.text")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_va_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (reload()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("errors.serverIssue.reload_button")), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})